import React from "react";

import Text from "shared/components/data-display/mui/Text";
import { Wrapper } from "./Unauthorized.styles";

const Unauthorized = (_props) => {
    return (
        <Wrapper className="unauth-msg-wrapper">
            <Text variant="largeBold">Unauthorized Access</Text>
            <Text variant="smallLight">
                You're trying to view a page to which you do not have access. If
                this is an error, please contact an adminstrator.
            </Text>
        </Wrapper>
    );
};

Unauthorized.propTypes = {};

export default Unauthorized;
